var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"padding-top":"10px"},attrs:{"fluid":""}},[(true)?_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"styleClass":"vgt-table condensed table-bordered table-striped","sort-options":{
                  enabled: true,
                  initialSortBy: {
                      field: 'name',
                      type: 'desc'
                  }
              },"pagination-options":{
                  enabled: true,
                  mode: 'records',
                  perPage: 50,
                  position: 'top',
                  perPageDropdown: [50, 100, 200],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
              }},on:{"on-row-click":_vm.onRowClick},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.label === 'Delete')?_c('span',[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.deleteParent(props.column.field,props.formattedRow[props.column.field])}}},[_vm._v("\n                          Admin Account Info\n              ")])],1):_c('span',[_vm._v("\n                      "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}],null,false,4191251465)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }